import React from 'react';
import { Typography, Button, Grid, Box, Link } from '@mui/material';
import ModalBase from '../Controls/ModalBase';
import { GetApp } from '@mui/icons-material';
import { GridActionsCellItem } from '@mui/x-data-grid';

const SinContacto = React.forwardRef((props, ref) => {
  const { open, setOpen, onClose } = props;

  const handleClose = () => {
    onClose();
  };

  const form = (
    <div>
      <Grid container direction='column' justifyContent='center' alignItems='center' spacing={1}>
        <Grid item>
          <Typography align='center' variant='body2' color='textSecondary'>
            Para activar su cuenta de usuario debe tener un correo electrónico registrado que
            constituya su <b>domicilio electrónico comercial.</b>
          </Typography>
          <br />
          <Typography align='center' variant='body2' color='textSecondary'>
            Para registrarlo debe presentar el formulario de actualización de datos{' '}
            <Link
              href='https://www.iosper.gov.ar/images/iosper_archivos/Formularios/formAltaProfesionales.pdf'
              target='_blank'
              download
            >
              <GetApp />
            </Link>{' '}
            firmado en la asociación médica correspondiente al convenio adherido con OSER o en
            alguna de las oficinas de la obra social, siendo en cualquier caso recepcionadas por la
            dirección de despacho de OSER.
          </Typography>
          <br />
        </Grid>
      </Grid>
      <Grid container direction='column' justifyContent='flex-end' alignItems='flex-end'>
        <Grid item>
          <Button size='small' variant='contained' color='primary' onClick={(e) => handleClose(e)}>
            Aceptar
          </Button>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <ModalBase
        open={open}
        setOpen={setOpen}
        content={form}
        title='Usuario sin domicilio electrónico constituido'
        onClose={handleClose}
      />
    </Box>
  );
});

export default SinContacto;
